export const CONTACT_US_MENU = 'contact_us_menu';
export const USER_MENU = 'user_menu';
export const CONTACT_CARD_MENU = 'contact_card_menu';
export const CONTACT_PANEL_MENU = 'contact_panel_menu';
export const RESPONSIVE_HEADER_MENU = 'responsive_header_menu';
export const BROADCAST_MENU = 'broadcast_menu';
export const READING_MORE_MENU = 'reading_more_menu';
export const EVENT_MENU = 'event_menu';
export const CAMPAIGN_MENU = 'campaign_menu';
